requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('cart.js', () => {
      class CartNotification extends HTMLElement {
        constructor() {
          super();

          this.notification = document.getElementById('cart-notification');
          this.onBodyClick = this.handleBodyClick.bind(this);

          subscribe(PUB_SUB_EVENTS.cartUpdateFinish, () => {
            this.show();
            // Auto-dismiss after 5s, paused on hover so the customer can
            // read / click the popup without it closing on them.
            const AUTO_HIDE_MS = 5000;
            const startAutoHide = () => {
              this.cancelAutoHide();
              this._autoHideTimer = setTimeout(() => this.close(), AUTO_HIDE_MS);
            };
            this.cancelAutoHide = () => {
              if (this._autoHideTimer) {
                clearTimeout(this._autoHideTimer);
                this._autoHideTimer = null;
              }
            };
            if (!this._autoHideListenersBound && this.notification) {
              this.notification.addEventListener('mouseenter', this.cancelAutoHide);
              this.notification.addEventListener('mouseleave', startAutoHide);
              this._autoHideListenersBound = true;
            }
            startAutoHide();
          });
          this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
          );
        }

        show() {
          this.notification.classList.add('animate', 'active');

          this.notification.addEventListener('transitionend', () => {}, {
            once: true
          });

          document.body.addEventListener('click', this.onBodyClick);
        }

        close() {
          this.notification.classList.remove('active');
          document.body.removeEventListener('click', this.onBodyClick);
        }

        handleBodyClick(event) {
          const target = event.target;
          if (target !== this.notification && !target.closest('cart-notification')) {
            this.close();
          }
        }
      }

      customElements.define('cart-notification', CartNotification);
    });
  });
});